import clsx from "clsx";
import { graphql } from "gatsby";
import React, { DetailedHTMLProps, FC, HTMLAttributes } from "react";

import { RichText } from "../rich-text";
import { HighlightItemTextAlign } from "./types";

export interface HighlightItemProps
  extends Queries.HighlightItemDataFragment,
    Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "style"> {
  titleClassName?: string;
  descriptionClassName?: string;
  className?: string;
}

export const HighlightItem: FC<HighlightItemProps> = ({
  className,
  textAlign,
  title,
  titleClassName,
  description,
  descriptionClassName,
  ...rest
}) => {
  return (
    <div
      className={clsx(className, textAlign === HighlightItemTextAlign.Center ? "text-center" : "")}
      {...rest}
    >
      <div className={clsx("text-3xl mb-2", titleClassName)}>{title}</div>
      <RichText className={descriptionClassName} raw={description?.raw} />
    </div>
  );
};

export const query = graphql`
  fragment HighlightItemData on ContentfulHighlightItem {
    title
    description {
      raw
    }
    textAlign
  }
`;
